import useSWR from 'swr';
import axios from 'axios';
import {getRelativeTime} from '../../helpers/utils';
import {Link} from 'react-router-dom';

export default function NewProfiles() {
  const fetcher = async (url) => {
    return await axios.get(url, {withCredentials: true, validateStatus: () => true});
  };
  const {data, error} = useSWR(`${process.env.REACT_APP_API_URL}/feeds/latest-profiles`, fetcher);

  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 pb-3">
      <div className="card-body d-flex align-items-center p-4">
        <h4 className="fw-700 mb-0 font-xssss text-grey-900">New to Hello.</h4>
      </div>
      {data !== undefined ? data.data.map((profile, index) => (
        <div className="wrap" key={index}>
          <Link to={`/p/${profile.tag}`} className="card-body d-flex ps-2 pe-2 pb-0 bor-0 p-2 bg-greylight bg-themedark-light ms-3 me-3 rounded-3 mb-2">
            <figure className="avatar me-3 m-0 mb-2"><img src={`${process.env.REACT_APP_API_URL}/image/${profile.pictureUid}/thumb.webp`} alt="avater" className="shadow-sm rounded-circle w45" /></figure>
            <h4 className="fw-700 text-grey-900 font-xssss mt-1">{profile.name} <span className="d-block font-xsssss fw-500 mt-1 lh-3 text-grey-500">Joined {getRelativeTime(new Date(profile.createdAt))}</span></h4>
          </Link>
        </div>
      )) : <></>}
    </div>
  );
}

